import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

export const REGISTER_WITH_CONSENT_MUTATION = gql`
    mutation RegisterWithConsent(
        $email: String!
        $password1: String!
        $password2: String!
        $securityQuestionQuestion: String!
        $securityQuestionAnswer: String!
        $consents: [ConsentInput]!
    ) {
        registerWithConsent(
            email: $email
            password1: $password1
            password2: $password2
            securityQuestionQuestion: $securityQuestionQuestion
            securityQuestionAnswer: $securityQuestionAnswer
            consents: $consents
        ) {
            success
            errors
            password
            password2
            token
            refreshToken
        }
    }
`

export type RegisterErrorField = {
    code?: string
    message?: string
}

export type RegisterErrors = {
    password?: (string | RegisterErrorField)[]
    password2?: (string | RegisterErrorField)[]
    [key: string]: (string | RegisterErrorField)[] | undefined
}

export type RegisterWithConsentMutation = {
    __typename?: 'Mutation'
    registerWithConsent?: {
        __typename?: 'RegisterWithConsent'
        success?: boolean | null
        errors?: string[] | null
        password?: string[] | null
        password2?: string[] | null
        token?: string | null
        refreshToken?: string | null
    } | null
}

export type RegisterWithConsentMutationVariables = {
    email: string
    password1: string
    password2: string
    securityQuestionQuestion: string
    securityQuestionAnswer: string
    consents: Array<{
        consentTypeId: string
        consentGiven: boolean
    }>
}

export type RegisterWithConsentMutationFn = Apollo.MutationFunction<
    RegisterWithConsentMutation,
    RegisterWithConsentMutationVariables
>

export function useRegisterWithConsentMutation(
    baseOptions?: Apollo.MutationHookOptions<RegisterWithConsentMutation, RegisterWithConsentMutationVariables>
) {
    const options = { ...baseOptions }
    return Apollo.useMutation<RegisterWithConsentMutation, RegisterWithConsentMutationVariables>(
        REGISTER_WITH_CONSENT_MUTATION,
        options
    )
}

export type RegisterWithConsentMutationHookResult = ReturnType<typeof useRegisterWithConsentMutation>
